/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import ApiErrorsAnalytics from './ApiErrors.analytics';
import { ApiErrorActions, TrackApiErrorParams } from './ApiErrors.meta';

export type { TrackApiErrorParams };

/**
 * Track API error
 * Returns mapped params for use with useLogger().logError('api_error', ...)
 */
export const trackApiError = (params: TrackApiErrorParams) => {
  const handler = ApiErrorsAnalytics[ApiErrorActions.API_ERROR];
  return typeof handler === 'function' ? handler(params) : params;
};
